import React from "react";

export default function AdminConfirmDialog({
  open,
  title = "Confirm",
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  isProcessing = false,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-start justify-center z-50 p-4 sm:items-center">
      <div className="relative bg-white rounded shadow-lg w-full max-w-md p-6 max-h-[90vh] overflow-y-auto">
        <button
          type="button"
          onClick={onCancel}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-3xl font-bold leading-none"
          aria-label="Close dialog"
          disabled={isProcessing}
        >
          &times;
        </button>
        <h2 className="text-xl font-semibold mb-4 text-gray-900">{title}</h2>
        {message && <p className="text-sm text-gray-700 mb-6 whitespace-pre-line">{message}</p>}
        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 border rounded text-sm"
            disabled={isProcessing}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={`px-4 py-2 rounded text-sm text-white ${isProcessing ? "bg-red-300 cursor-not-allowed" : "bg-red-600 hover:bg-red-700"}`}
            disabled={isProcessing}
          >
            {isProcessing ? "Deleting..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
